import request from '@/utils/request';

/**
 * 人才(RC) 后台模块接口
 * 轮播图 / 服务内容配置 / 政策资讯 / 跳转按钮 / 酒店管理
 */
export function rcApis() {
    return {
        /** ============ 人才服务轮播图 ============ */
        BannerList: params => request({ url: '/admin/rc/banner/index', method: 'get', params }),
        BannerInfo: params => request({ url: '/admin/rc/banner/info', method: 'get', params }),
        BannerEdit: params => request({ url: '/admin/rc/banner/edit', method: 'post', data: params }),
        BannerDel: params => request({ url: '/admin/rc/banner/del', method: 'get', params }),

        /** ============ 服务内容配置 ============ */
        ServiceConfigInfo: params => request({ url: '/admin/rc/service_config/info', method: 'get', params }),
        ServiceConfigSave: params => request({ url: '/admin/rc/service_config/save', method: 'post', data: params }),

        /** ============ 政策资讯 ============ */
        PolicyList: params => request({ url: '/admin/rc/policy/index', method: 'get', params }),
        PolicyInfo: params => request({ url: '/admin/rc/policy/info', method: 'get', params }),
        PolicyEdit: params => request({ url: '/admin/rc/policy/edit', method: 'post', data: params }),
        PolicyDel: params => request({ url: '/admin/rc/policy/del', method: 'get', params }),

        /** ============ 跳转按钮 ============ */
        JumpButtonList: params => request({ url: '/admin/rc/jump_button/index', method: 'get', params }),
        JumpButtonInfo: params => request({ url: '/admin/rc/jump_button/info', method: 'get', params }),
        JumpButtonEdit: params => request({ url: '/admin/rc/jump_button/edit', method: 'post', data: params }),
        JumpButtonDel: params => request({ url: '/admin/rc/jump_button/del', method: 'get', params }),

        /** ============ 酒店管理 ============ */
        HotelList: params => request({ url: '/admin/rc/hotel/index', method: 'get', params }),
        HotelInfo: params => request({ url: '/admin/rc/hotel/info', method: 'get', params }),
        HotelEdit: params => request({ url: '/admin/rc/hotel/edit', method: 'post', data: params }),
        HotelDel: params => request({ url: '/admin/rc/hotel/del', method: 'get', params }),

        /** ============ 酒店预约审核 ============ */
        AppointmentList: params => request({ url: '/admin/rc/appointment/index', method: 'get', params }),
        AppointmentAudit: params => request({ url: '/admin/rc/appointment/audit', method: 'post', data: params }),
    };
}
